module.exports = __webpack_public_path__ + "static/media/SDGIcons_9.116227b4.png";